import React from "react";
import { useNavigate } from "react-router";
import CreateNewTrip from "src/components/Buttons/CreateNewTrip";
import Footer from "src/components/Footer";
import Header from "src/components/Header";

function Home() {
  const navigate = useNavigate();

  return (
    <>
      <div className="relative z-10 h-full w-full flex flex-col items-center justify-center mx-[16px]">
        <div className="w-full items-center justify-center flex px-2 md:px-[15%]">
          <Header isUserLoggedIn={true} onPress={() => navigate("/waitlist")} />
        </div>
        <div className="flex flex-col h-full w-full items-center justify-center">
          <div className="flex h-full w-full items-center justify-center">
            <CreateNewTrip onClick={() => navigate("/waitlist")} />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Home;
